import './about.css';
import './careers.css';


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faChevronRight, 
  faUsers, 
  faChartLine, 
  faRocket, 
  faLaptopCode, 
  faPenNib, 
  faHeadset, 
  faPaperPlane, 
  faCheckCircle, 
  faComments,
  faBriefcase,
  faHandshake,
  faGift
} from "@fortawesome/free-solid-svg-icons";





const Cariere = () => {
  return (
  
      <div className="general-container-footer-info-ab">
                 <div className="info-footer-container-ab">
           
                   <section className='section-about-1'>
                       <div>
                           <h3 className='align-about-ab'>
             <span className='acasa-about-footer'>Acasa</span>
             <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-icon" />
           
             <span className='color-despre'>Cariere</span>
           </h3>
                       </div>
                     
                     
                   </section>


                     <div className='tittle-ab-top'>
                        <h4>Alatura-te echipei ContaLearn</h4>
                    </div>

                    <div className='career-hero'>
                      <p className='hero-subtitle'>Construim viitorul educatiei financiare in Romania</p>
                      <div className='stats-career'>
                        <div className='stat-item-career'>
                          <FontAwesomeIcon icon={faUsers} className='stat-icon-career' />
                          <div className='stat-number-career'>10,000+</div>
                          <div className='stat-label-career'>Utilizatori activi</div>
                        </div>
                        <div className='stat-item-career'>
                          <FontAwesomeIcon icon={faChartLine} className='stat-icon-career' />
                          <div className='stat-number-career'>300+</div>
                          <div className='stat-label-career'>Lectii interactive</div>
                        </div>
                        <div className='stat-item-career'>
                          <FontAwesomeIcon icon={faRocket} className='stat-icon-career' />
                          <div className='stat-number-career'>100%</div>
                          <div className='stat-label-career'>Remote & Flexibil</div>
                        </div>
                      </div>
                    </div>

<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faBriefcase} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>De ce ContaLearn?</h4>
    <p>
      Alatura-te misiunii noastre de a face contabilitatea mai simpla si mai accesibila pentru toata lumea.
    </p>
    <p>
      Credem ca educatia financiara si contabila ar trebui sa fie clara, interactiva si aplicata. Daca si tu crezi in puterea educatiei digitale si vrei sa contribui la construirea unei platforme care face diferenta, locul tau poate fi alaturi de noi.
    </p>
    <p>
      Suntem mereu in cautare de oameni pasionati, curiosi si deschisi la invatare - indiferent de experienta.
    </p>
  </div>
</section>


<div className='section-header-career'>
  <h2>Roluri deschise</h2>
  <p className='section-subtitle-career'>Alege domeniul care ti se potriveste</p>
</div>

<section className="open-roles">
  <div className="job-category">
    <div className='job-category-header'>
      <FontAwesomeIcon icon={faPenNib} className='job-icon' />
      <h3>Content</h3>
      <span className='job-badge'>3 pozitii</span>
    </div>
    <p>
      Creaza continut educational relevant, clar si aplicat — de la lectii si articole, la quizuri si simulari.
    </p>
    <ul className='job-list'>
      <li><span className='job-title'>Redactor contabilitate</span><span className='job-type'>Part-time / Remote</span></li>
      <li><span className='job-title'>Editor fiscalitate</span><span className='job-type'>Freelance</span></li>
      <li><span className='job-title'>Intern content e-learning</span><span className='job-type'>Internship</span></li>
    </ul>
  </div>

  <div className="job-category">
    <div className='job-category-header'>
      <FontAwesomeIcon icon={faLaptopCode} className='job-icon' />
      <h3>Design & Tech</h3>
      <span className='job-badge'>2 pozitii</span>
    </div>
    <p>
      Ajuta-ne sa construim o experienta de invatare fluida, moderna si intuitiva.
    </p>
    <ul className='job-list'>
      <li><span className='job-title'>Front-End Developer (React)</span><span className='job-type'>Part-time</span></li>
      <li><span className='job-title'>UX/UI Designer educational</span><span className='job-type'>Freelance</span></li>
    </ul>
  </div>

  <div className="job-category">
    <div className='job-category-header'>
      <FontAwesomeIcon icon={faHeadset} className='job-icon' />
      <h3>Suport & Comunitate</h3>
      <span className='job-badge'>2 pozitii</span>
    </div>
    <p>
      Sprijina utilizatorii ContaLearn si ajuta-ne sa construim o comunitate activa si implicata.
    </p>
    <ul className='job-list'>
      <li><span className='job-title'>Customer Support Specialist</span><span className='job-type'>Part-time</span></li>
      <li><span className='job-title'>Intern comunicare / social media</span><span className='job-type'>Internship</span></li>
    </ul>
  </div>

  <div className='open-application'>
    <FontAwesomeIcon icon={faPaperPlane} className='open-app-icon' />
    <p>Nu vezi un rol care ti se potriveste? <strong>Trimite-ne oricum CV-ul!</strong></p>
  </div>
</section>





<div className='section-header-career'>
  <h2>Cum lucram</h2>
  <p className='section-subtitle-career'>Cultura noastra de lucru</p>
</div>

<section className="how-we-work">
  <div className="grid-3">
    <div className='work-card'>
      <div className='work-emoji'>📍</div>
      <h4>100% Remote</h4>
      <p>Colaborezi de oriunde. Ne intalnim online, ne organizam cu async tools.</p>
    </div>
    <div className='work-card'>
      <div className='work-emoji'>🕒</div>
      <h4>Flexibilitate</h4>
      <p>Lucrezi cand poti, cat poti — atat timp cat comunicam clar si ne respectam deadline-urile.</p>
    </div>
    <div className='work-card'>
      <div className='work-emoji'>🚀</div>
      <h4>Beta mindset</h4>
      <p>Testam rapid idei, iteram, imbunatatim. Nici noi nu ne oprim din invatat.</p>
    </div>
  </div>
</section>





           


<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Cautam colegi care:</h4>
    <ul className='values-list'>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> Vor sa contribuie la o platforma educativa cu impact real</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> Gandesc creativ si gasesc solutii</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> Comunica deschis si colaboreaza bine in echipa</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> Inteleg importanta educatiei practice si orientate spre viitor</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> Sunt pasionati de educatie si tehnologie</li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faHandshake} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>



<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faGift} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Ce oferim:</h4>
    <ul className='benefits-list'>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> <strong>Colaborare remote</strong> — lucrezi de oriunde</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> <strong>Program flexibil</strong> — potrivit pentru freelanceri, studenti sau profesori</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> <strong>Proiect cu misiune</strong> — educatie financiara accesibila</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> <strong>Mediu prietenos</strong> — deschis la idei si initiativa</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> <strong>Impact real</strong> — contribui vizibil la dezvoltarea produsului</li>
    </ul>
  </div>
</section>

<div className='section-header-career'>
  <h2>Procesul de aplicare</h2>
  <p className='section-subtitle-career'>3 pasi simpli pana la colaborare</p>
</div>

<div className='application-process'>
  <div className='process-step'>
    <div className='step-number'>1</div>
    <h4>Trimite CV-ul</h4>
    <p>Scrie-ne la <strong>jobs@contalearn.ro</strong> si spune-ne de ce te motiveaza ContaLearn</p>
  </div>
  <div className='process-step'>
    <div className='step-number'>2</div>
    <h4>Discutie informala</h4>
    <p>Vorbim online despre tine, proiect si cum ai putea contribui</p>
  </div>
  <div className='process-step'>
    <div className='step-number'>3</div>
    <h4>Start colaborare</h4>
    <p>Stabilim detaliile si incecem sa construim impreuna viitorul educatiei</p>
  </div>
</div>

<div className='final-cta-career'>
  <div className='cta-content-career'>
    <h3>Gata sa faci diferenta?</h3>
    <p>ContaLearn creste. Vrei sa cresti si tu cu noi?</p>
    <a href='mailto:jobs@contalearn.ro' className='cta-button-career'>
      <FontAwesomeIcon icon={faPaperPlane} />
      Trimite CV-ul acum
    </a>
    <p className='cta-email'>sau scrie direct la: <strong>jobs@contalearn.ro</strong></p>
  </div>
</div>

           
               
           
                 </div>
               </div>
 
  );
};

export default Cariere;
